module.exports = __webpack_public_path__ + "static/media/poster.7129a2f6.png";